import { Link } from "react-scroll";
import logo from "../assets/logo.png";

const Header = () => {
  return (
    <header className="py-8">
    <div className="container mx-auto">
      <div className="flex gap-4 justify-between items-center">
        {/* logo */}
        <a href="/"> 
          <img className="w-36 md:w-8/12" src={logo} alt="Portfolio Logo" />
        </a>
        {/* Button */}
        <Link to="contact" smooth={true} spy={true}>
          <button className="btn text-[11px] md:text-base py-1 px-3 md:py-3 md:px-5">
            Work With Me
          </button>
        </Link>
      </div>
    </div>
  </header>
  );
};

export default Header;
